<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('inversions')">Inversión</inertia-link>
      <span class="text-white font-medium">/ {{ form.cliente }}
      </span>
    </h1>
    <trashed-message v-if="inversion.estado!='Vigente'" class="mb-6" @restore="restore">
     Inversión  Eliminado!
    </trashed-message>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-4xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-1/5">
           <label style="color: white; font-weight: 700;" class="form-label" >Fecha inicio:</label>
           <datetime format="MM/DD/YYYY h:i:s" :class="bg-inexgray"  v-model="form.inicio" width="300px" name='dob'>
           </datetime>          
          </div>
        <text-input v-model="form.cliente" :error="form.errors.cliente" class="pr-6 pb-8 w-full lg:w-3/5" label="Cliente" disabled/>
          
          <text-input v-model="form.monto" :error="form.errors.monto" class="pr-6 pb-8 w-full lg:w-1/5" label="Monto $" required/>
          <div class="pr-6 pb-8 w-full lg:w-1/5">
           <label style="color: white; font-weight: 700;" class="form-label" >Fecha final:</label>
           <datetime format="MM/DD/YYYY h:i:s" v-model="form.final" width="300px" name='dob'>
           </datetime>          
          </div>
          <div  class="container pr-6 pb-8 w-full lg:w-2/5">
            <label style="color: white; font-weight: 700;" class="form-label" >Tipo:</label>
            <v-select style="color: white; background-color: inexinput;" v-model="form.tipo" :options="tiposs" value="id" label="nombres">
            </v-select>
          </div>   
        <text-input v-model="form.id_inversion" :error="form.errors.id_inversion" class="pr-6 pb-8 w-full lg:w-2/5" label="Inversion ID" required/>
        <text-input v-model="form.porcentaje" :error="form.errors.porcentaje" class="pr-6 pb-8 w-full lg:w-2/5" label="Porcentaje" required/>
        <text-input v-model="form.tiempo" :error="form.errors.tiempo" class="pr-6 pb-8 w-full lg:w-2/5" label="Tiempo Inv." required/>

    

      </div>
      <br><br>
        <br><br>
        <br><br>
        <div class="px-8 py-4 bg-transparent flex justify-between items-center">
          <button v-if="inversion.estado=='Vigente'" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Inversión</button>          
          <button v-if="inversion.estado=='Vigente'" class="text-inexorange hover:underline" tabindex="-1" type="button" @click="cancel">Cancelar Inversión</button>

          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Actualizar Inversión</loading-button>
        </div>
      </form>
    </div>
  </div> 
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import datetime from 'vuejs-datetimepicker';
export default {
  metaInfo() {
    return {
      title: `${this.form.cliente}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    datetime,
    vSelect
  },
  layout: Layout,
  props: {
    inversion: Object,
    organizations: Array,
    cliente: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        inicio: this.inversion.inicio,
        cliente: this.cliente.nombres_completos,
        final: this.inversion.final,
        id_inversion: this.inversion.id_inversion,
        tipo: this.inversion.tipo,
        monto: this.inversion.monto,
        porcentaje: this.inversion.porcentaje,
        tiempo: this.inversion.tiempo,
        ganado: this.inversion.ganado,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('inversions.update', this.inversion.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('inversions.destroy', this.inversion.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('inversions.restore', this.inversion.id))
      }
    },
    cancel() {
      if (confirm('Está seguro de cancelar la penalidad es del 35%?')) {
        this.$inertia.delete(this.route('inversions.destroyc', this.inversion.id))
      }
    },
  },
}
</script>
